import { createContext } from 'react';
import { defaultAccountsProps } from './constants';
export const AccountsPropsContext = /*#__PURE__*/createContext(defaultAccountsProps);